import httpClient from '@/api/http-client';

const endpoint = 'api/permit-cards';

const permitCardService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  create: (permitCard) => httpClient.post(`${endpoint}`, permitCard),

  update: (permitCard) => httpClient.put(`${endpoint}/${permitCard.id}`, permitCard),

  delete: (permitCard) => httpClient.delete(`${endpoint}/${permitCard.id}`),
};

export default permitCardService;
